import React, { useState, useEffect, memo } from "react";
import MemberServices from "../../../../../services/MemberService";
import Constants from "../../../../../common/Constants";
import { get } from "lodash";

const CountdownComponent = ({ t, disableUpdateBtn, resendData }) => {
  const [seconds, setSeconds] = useState(Constants.MFA_CONSTANTS.RESEND_DELAY);
  const [isCountdownResent, setIsCountdownResent] = useState(true);
  const [isLoading, setIsLoading] = useState(false)
  const { ACTION_TYPE, MODE } = Constants.LOGIN_2FA;

  useEffect(() => {
    if (seconds <= 0 && isCountdownResent) {
      onCountdownFinish();
      return;
    }
    const timer = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [seconds]);

  const onCountdownFinish = () => {
    setIsCountdownResent(false);
  }

  const onResendOtp = async (event) => {
    event.preventDefault();
    setIsLoading(true)
    try {
      let res = {};
      switch (resendData.mode) {
        case MODE.LOGIN:
          res = await MemberServices.resendOtpLogin2FA({ 
            loginId: resendData.loginId, 
            actionType: ACTION_TYPE.LOGIN_2FA_USER_VERIFIED_OTP_REQUIRE 
          });
          break;
      
        case MODE.CHANGE_SETTING:
          res = await MemberServices.resendOtpLogin2FA({ 
            loginId: resendData.loginId, 
            actionType: ACTION_TYPE.LOGIN_2FA_CHANGE_SETTING_OTP_REQUIRE 
          });
          break;
      
        default:
          res = await MemberServices.sendOtpToEmail();
          break;
      }
      const data = get(res, 'data', null)
      if (data || (data === Constants.MFA_CONSTANTS.OTP_SAVE_SUCCESS)) {
        setIsCountdownResent(true)
        setSeconds(Constants.MFA_CONSTANTS.RESEND_DELAY)
        setIsLoading(false)
      }
    } catch (error) {
      return error;
    }
  };

  const formatTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const secsRemaining = secs % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secsRemaining).padStart(2, "0")}`;
  };

  if (!disableUpdateBtn) return null;

  return isCountdownResent
    ? <span className="countdown_label">{t('RESENT_OTP_IN')} <span className="countdown_num">{formatTime(seconds)}</span></span>
    : <button
      className="countdown_label can_send"
      onClick={onResendOtp}
      disabled={isLoading}
    >{t('RESEND_OTP')}</button>
};

export default memo(CountdownComponent);



// WEBPACK FOOTER //
// ./src/app/components/MainComponent/AccountComponent/AsiaView/MbAsiaMultiFactorAuthenticationComponent/CountdownComponent.js